import groupService from '../../../services/group-service';
import { Group } from '../../interfaces';
import { extractRouteById } from '../../../utils/group';
import DialogComponent, { DialogProps } from '../../widgets/dialog/DialogComponent';

import './ChangeParentDialog.scss';

export interface Props extends DialogProps {
  groups: Group[];
  selected: { _id: string }[];
}

export default class ChangeParentDialog extends DialogComponent<Props> {

  state = {
    children: []
  }

  render() {
    const { selected } = this.props;
    const groups = this.filter();
    console.log('Filtered Groups', groups);
    return (
      <ul className="change-parent-list-component">
        <li
          value={null}
          onClick={this.submit.bind(this, { selected, parent: null })}>Root - ریشه</li>
        {groups.map(item => (
          <li
            key={item._id}
            className="ltr"
            onClick={this.submit.bind(this, { selected, parent: item._id })}>
            {extractRouteById(item._id, groups, 'Root/')}
          </li>
        ))}
      </ul>
    );
  }

  componentDidMount = async () => {
    const { selected } = this.props;
    let children = [];
    for (const item of selected) {
      children = [...children, ...(await groupService.fetchChildren(item._id))];
    }
    this.setState({ children });
  }

  filter = () => {
    const { children } = this.state;
    const { groups, selected } = this.props;
    return groups.filter(group => {
      const isChild = children.find(item => item._id === group._id);
      return !isChild && !selected.find(s => s._id === group._id);
    });
  }

  submit = (data: any) => {
    this.resolve(data);
    this.close();
  }

}
